import { render } from "./ShowCourse.vue?vue&type=template&id=1403ca52&scoped=true"
import script from "./ShowCourse.vue?vue&type=script&lang=js"
export * from "./ShowCourse.vue?vue&type=script&lang=js"

import "./ShowCourse.vue?vue&type=style&index=0&id=1403ca52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1403ca52"]])

export default __exports__